module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-regular.731a28a413d642522667.ttf";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-regular.ttf
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-regular.ttf
// module chunks = styles